import { LockIcon } from '@chakra-ui/icons';
import {
  Badge,
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface AccessDeniedProps {
  title?: string;
  message?: string;
  userRole?: string;
  permissionGroup?: string;
  showNavigation?: boolean;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({
  title = 'Access Denied',
  message = "Sorry, you don't have access to this screen according to your permission group",
  userRole = 'Unknown',
  permissionGroup = 'No specific permissions',
  showNavigation = true,
}) => {
  const navigate = useNavigate();
  return (
    <Flex
      minH="100vh"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
    >
      <Box
        borderWidth="1px"
        borderRadius="lg"
        boxShadow="sm"
        p={[4, 6]}
        textAlign={'center'}
        bg="white"
        mx="2"
        maxW="md"
      >
        <LockIcon boxSize={[8, 10]} color="red.400" mb={4} />

        <Heading size="lg" mb={2} color={'gray.800'}>
          {title}
        </Heading>

        <Text mb={4} color={'gray.600'}>
          {message}
        </Text>

        <VStack spacing={3} mb={6}>
          <Text fontSize="sm" fontWeight="600" color="gray.700">
            Your Current Permissions:
          </Text>

          <HStack spacing={3} justify="center">
            <Badge colorScheme="blue" variant="subtle" px={3} py={1}>
              Role: {userRole}
            </Badge>

            <Badge colorScheme="gray" variant="subtle" px={3} py={1}>
              {permissionGroup}
            </Badge>
          </HStack>
        </VStack>

        {showNavigation && (
          <HStack
            gap="1rem"
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <Button
              colorScheme="blue"
              variant={'outline'}
              onClick={() => navigate('/')}
            >
              Go to Home
            </Button>
            <Button
              colorScheme="blue"
              onClick={() => navigate('/profile')}
            >
              View My Profile
            </Button>
          </HStack>
        )}
      </Box>
    </Flex>
  );
};

export default AccessDenied;
